window.currency_symbol = '£';

function get_selected_filters(t) {
  var i = t
      .find('ul.colours li.outline')
      .map(function () {
        return $(this).data('colour');
      })
      .get()
      .join(',')
      .split(','),
    e = t
      .find('ul.tags li.outline')
      .map(function () {
        return $(this).data('tag');
      })
      .get()
      .join(',')
      .split(','),
    a = $.merge(i, e);
  t.find('input#outfit-filter-tags').val(a.filter(Boolean).join(', '));
}
function filter_outfits(t) {
  var i = t.find('input#outfit-filter-tags').val(),
    e = t.find('input#outfit-filter-collection').val(),
    a = i.split(', ');
  ($.inArray('all-colours', a) > -1 && a.splice(a.indexOf('all-colours'), 1),
    $.inArray('all-tags', a) > -1 && a.splice(a.indexOf('all-tags'), 1),
    a.filter(Boolean));
  if ('' !== e) {
    var s = e + '?view=outfit-builder';
    $.ajax({
      url: s,
      type: 'GET',
      beforeSend: function () {
        (t.find('span.no-results').remove(),
          t.find('div.products').addClass('loading'),
          !t.find('span.products-count').parent('span.title').find('span.ajax-loader').length > 0 &&
            t
              .find('span.products-count')
              .parent('span.title')
              .append('<span class="ajax-loader"><span>'));
      },
      success: function (i) {
        var e = 0,
          s = JSON.parse(i);
        (s.products &&
          (t.find('div.products').empty(),
          $.each(s.products, function (i, s) {
            null == s.compare_at_price &&
              (a && a.length > 0
                ? 1 == find_common_elements(a, s.tags) &&
                  (e++, t.find('div.products').append(s.data))
                : (e++, t.find('div.products').append(s.data)));
          })),
          0 == e &&
            $('<span class="px-offset no-results">No products found</span>').insertBefore(
              t.find('div.products'),
            ),
          t.find('span.products-count').text(e),
          t.find('span.ajax-loader').remove(),
          t.find('div.products').removeClass('loading'));
      },
    });
  }
}
function update_outfit_btn_state(t) {
  if (
    ($('div#review div.outfit-cart div.outfit-cart__total .outfit-add-to-bag').prop('disabled'),
    1 == t)
  ) {
    var i = [];
    (i.push({
      notice: $('input#cart-item-clothing-1').attr('data-notice'),
      variant: $('input#cart-item-clothing-1').val(),
    }),
      i.push({
        notice: $('input#cart-item-clothing-2').attr('data-notice'),
        variant: $('input#cart-item-clothing-2').val(),
      }),
      i.push({
        notice: $('input#cart-item-clothing-3').attr('data-notice'),
        variant: $('input#cart-item-clothing-3').val(),
      }),
      '0' !== $('input#cart-item-clothing-4').attr('data-cost') &&
        i.push({
          notice: $('input#cart-item-clothing-4').attr('data-notice'),
          variant: $('input#cart-item-clothing-4').val(),
        }),
      (notices = ''),
      (disabled_array = []),
      i &&
        i.length > 0 &&
        ($.each(i, function (t, i) {
          '' == i.variant
            ? ((notices +=
                '<span>Please select <strong>' +
                i.notice +
                ' Size</strong> to finish your outfit.</span>'),
              disabled_array.push(!0))
            : disabled_array.push(!1);
        }),
        $('div#review div.outfit-cart div.outfit-cart__total div.notice').empty().append(notices)),
      -1 == $.inArray(!0, disabled_array) &&
        $('div#review div.outfit-cart div.outfit-cart__total .outfit-add-to-bag').prop(
          'disabled',
          false,
        ));
  }
}
function update_outfit_cart() {
  var t =
      parseInt($('input#cart-item-clothing-1').attr('data-cost')) *
      parseInt($('input#cart-item-clothing-1').attr('data-quantity')),
    i =
      parseInt($('input#cart-item-clothing-2').attr('data-cost')) *
      parseInt($('input#cart-item-clothing-2').attr('data-quantity')),
    e =
      parseInt($('input#cart-item-clothing-3').attr('data-cost')) *
      parseInt($('input#cart-item-clothing-3').attr('data-quantity')),
    a =
      parseInt($('input#cart-item-clothing-4').attr('data-cost')) *
      parseInt($('input#cart-item-clothing-4').attr('data-quantity')),
    s = parseInt(t + i + e + a);
  if (0 == t || 0 == i || 0 == e) var o = !1;
  else o = !0;
  var r = '';
  if (0 == o)
    r +=
      '<span class="text-lg text-highlight OLD: price"><span class="money" data-currency-gbp="£' +
      (s / 100).toFixed(2) +
      '">' +
      currency_symbol +
      (s / 100).toFixed(2) +
      '</span></span>';
  else {
    var d = $('input#cart-calculations').data('percentage'),
      n = s - (s / 100) * d;
    r +=
      '<div class="flex gap-2"><span class="text-highlight OLD: price now sale"><span class="money" data-currency-gbp="£' +
      (n / 100).toFixed(2) +
      '">' +
      currency_symbol +
      (n / 100).toFixed(2) +
      '</span></span><span class="OLD: price was"><s class="money" data-currency-gbp="£' +
      (s / 100).toFixed(2) +
      '">' +
      currency_symbol +
      (s / 100).toFixed(2) +
      '</s></span></div><p class="empty:hidden mt-1 bg-highlight text-white inline-block px-2 py-1 OLD: saving">' +
      d +
      '% Off</p>';
  }
  (update_outfit_btn_state(o),
    $('div#review div.outfit-cart div.outfit-cart__total div.cart-total').html(r),
    document.getElementsByTagName('klarna-placement')[0].setAttribute('data-purchase-amount', s),
    (window.KlarnaOnsiteService = window.KlarnaOnsiteService || []),
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' }));
}
function reset_preselected_outfits(t) {
  ($(
    'div.outfit-filter div.column.product-filters ul.colours li[data-colour="all-colours"]',
  ).click(),
    $('div.outfit-filter div.column.product-filters ul.tags li[data-tag="all-tags"]').click(),
    $(document).ajaxStop(function () {
      filter_preselected_outfits(t);
    }));
}
function filter_preselected_outfits(t) {
  ($(
    'div.outfit-filter[data-item="4"] div.column.product-filters div.product-filters__products div.products div.product',
  ).each(function (t) {
    $(this).removeClass('outline');
  }),
    $('div.outfit-filter[data-item="4"] div.column.product-preview')
      .empty()
      .append(
        //'<div class="image-wrapper hidden"><span class="preview-btn"><svg version="1.1" id="search" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><path d="M20.7,23.4l-7-7c-1.3,0.8-2.9,1.3-4.5,1.3c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5c0,1.7-0.5,3.2-1.3,4.5l7,7C23.4,20.7,20.7,23.4,20.7,23.4z M9.2,15.8c3.7,0,6.6-3,6.6-6.6s-3-6.6-6.6-6.6s-6.6,3-6.6,6.6S5.5,15.8,9.2,15.8z" /></svg></span><img class="group-hover:opacity-0 transition-opacity OLD: preview" src="#"><img class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity OLD: rollover" src="#"></div>',
        `<div class="group relative OLD: image-wrapper hidden">
          <img class="group-hover:opacity-0 transition-opacity OLD: preview" src="#">
          <img class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity OLD: rollover" src="#">
        </div>`,
      ),
    $('div.outfit-filter[data-item="4"] div.column.product-data')
      .empty()
      .append(
        //'<div class="product-data__info"><div class="column column-one"><p class="title"></p><div class="price"></div></div><div class="column column-two"><a class="cta cta-light quickview" data-fancybox="quickview" data-type="ajax" data-src="" href="javascript:;">Quickview</a></div></div><div class="product-data__match"><a class="product-match trouser-match hidden" href="#" data-products=""><span class="icon"><svg version="1.1" id="trousers" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 24 24" xml:space="preserve"><path d="M6.606 23.995H9.48a.317.317 0 00.204-.072.325.325 0 00.113-.188L12 10.11l2.202 13.613a.319.319 0 00.318.26h2.875a.317.317 0 00.221-.09.326.326 0 00.098-.221L17.356 2.27V.324a.326.326 0 00-.093-.229.318.318 0 00-.227-.095H6.964a.317.317 0 00-.226.095.327.327 0 00-.094.23v1.94L6.286 23.67a.328.328 0 00.196.304c.04.017.081.025.124.025v-.005zM13.819.649h2.898v1.297h-2.898V.649zm2.898 1.945v1.598c-.768-.22-1.023-1.103-1.126-1.598h1.126zm-2.898 3.992V2.594h1.123c.127.85.616 2.075 1.818 2.27l.31 18.482h-2.28L12.374 8.405c1.067-.169 1.418-1.217 1.446-1.819zM12.319.65h.86v1.297h-.86V.649zm0 1.945h.86v3.977c0 .044-.061 1.011-.86 1.185V2.594zM7.284.649h4.397v1.297H7.283V.649zm0 1.945H8.42c-.092.495-.363 1.375-1.123 1.598l-.013-1.598zm-.043 2.27c1.202-.195 1.69-1.42 1.818-2.27h2.622V8.08L9.21 23.346H6.93l.31-18.482z"/></svg></span><span class="text">Match Trousers</span></a><a class="product-match jacket-match hidden" href="#" data-products=""><span class="icon"><svg version="1.1" id="jacket" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 37.9 30" xml:space="preserve"><path d="M21.2 20.3l.2-.1 2.4 2.8-.2.1-2.4-2.8zm-8.6 2.5l2.8-2.3.1.2-2.8 2.3-.1-.2z"/><path d="M33.7 25.4l3.3-2.7-.9-1.5-9.2-16.4-3.4-1.2L22.4.9h-7.5l-1.3 2.9-3.7 1.3-8.4 17.7-.7 1.6L4.4 27l.8-1.5 4.5-9V29h17V15.6l5.5 7.7 1.5 2.1zm2.5-2.9l-2.3 1.9-.6-.7 2.3-1.9.6.7zM22.8 3.6l-2.6 1.9-.8-.6 2.8-2.7.6 1.4zm-1.1-2l-1.4 1.3h-3.4l-1.4-1.3h6.2zm-6.6.5l2.8 2.7-.8.6-2.7-1.9.7-1.4zm-10.9 24l-2.5-1.8.4-1 2.6 1.9-.5.9zM9.7 15l-4.8 9.6-2.6-1.9 7.8-16.5v.4c.1 1.8.1 5.3-.4 8.4zm8.6 13.3h-7.9v-1.1h7.9v1.1zm0-1.9h-7.9V15.2c.6-3.9.5-8.4.4-9.7v-.1l3.5-1.2 2.9 2.1 1.1-.9v21zm-.7-22.8h2l-1 1-1-1zm8.5 24.7H19v-1.1h7.1v1.1zm0-1.9H19v-21l1.2.9 2.9-2.1 2.6.9v.1c0 .9-.2 5.8.4 10v11.2zm.6-12c-.4-3.5-.4-7.3-.3-8.8v-.4l.2.3 8.7 15.6-2.4 1.9-6.2-8.6z"/><path d="M20.7 13.6h3.2V9.4h-3.2v4.2zm.7-3.5h1.8v2.8h-1.8v-2.8zm-9.6 12.6l.9 1 3.7-3.1-.9-1-3.7 3.1zm.9.5l-.4-.4 3.1-2.6.4.4-3.1 2.6zm7.7-3l3.1 3.7 1-.9-3.1-3.7-1 .9zm3.1 3.2l-2.6-3.1.4-.4 2.6 3.1-.4.4z"/></svg></span><span class="text">Match Jacket</span></a></div><div class="product-data__sizing"><ul class="sizing product-outfit" data-id=""></ul></div>',
        `<div class="OLD: product-data__info">
              <div class="OLD: column column-one">
                <p class="text-heading-sm OLD: title"></p>
                <div class="price"></div>
              </div>
            </div>
            <div class="product-data__match">
              <a class="inline-flex items-center gap-1 h-8 px-2 border border-scheme-links rounded-full text-scheme-links text-sm my-2 outline-1 outline-offset-2 outline-scheme-links OLD: product-match trouser-match hidden" href="#" data-products="">
                <span class="icon">
                  <svg
                    class="h-5"
                    version="1.1"
                    id="trousers"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    viewBox="0 0 24 24"
                    xml:space="preserve"
                  >
                    <path d="M6.606 23.995H9.48a.317.317 0 00.204-.072.325.325 0 00.113-.188L12 10.11l2.202 13.613a.319.319 0 00.318.26h2.875a.317.317 0 00.221-.09.326.326 0 00.098-.221L17.356 2.27V.324a.326.326 0 00-.093-.229.318.318 0 00-.227-.095H6.964a.317.317 0 00-.226.095.327.327 0 00-.094.23v1.94L6.286 23.67a.328.328 0 00.196.304c.04.017.081.025.124.025v-.005zM13.819.649h2.898v1.297h-2.898V.649zm2.898 1.945v1.598c-.768-.22-1.023-1.103-1.126-1.598h1.126zm-2.898 3.992V2.594h1.123c.127.85.616 2.075 1.818 2.27l.31 18.482h-2.28L12.374 8.405c1.067-.169 1.418-1.217 1.446-1.819zM12.319.65h.86v1.297h-.86V.649zm0 1.945h.86v3.977c0 .044-.061 1.011-.86 1.185V2.594zM7.284.649h4.397v1.297H7.283V.649zm0 1.945H8.42c-.092.495-.363 1.375-1.123 1.598l-.013-1.598zm-.043 2.27c1.202-.195 1.69-1.42 1.818-2.27h2.622V8.08L9.21 23.346H6.93l.31-18.482z"/>
                  </svg>
                </span>
                <span class="text">Match Trousers</span>
              </a>
              <a class="inline-flex items-center gap-1 h-8 px-2 border border-scheme-links rounded-full text-scheme-links text-sm my-2 outline-1 outline-offset-2 outline-scheme-links OLD: product-match jacket-match hidden" href="#" data-products="">
                <span class="icon">
                  <svg
                    class="h-5"
                    version="1.1"
                    id="jacket"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    viewBox="0 0 37.9 30"
                    xml:space="preserve"
                  >
                    <path d="M21.2 20.3l.2-.1 2.4 2.8-.2.1-2.4-2.8zm-8.6 2.5l2.8-2.3.1.2-2.8 2.3-.1-.2z"/><path d="M33.7 25.4l3.3-2.7-.9-1.5-9.2-16.4-3.4-1.2L22.4.9h-7.5l-1.3 2.9-3.7 1.3-8.4 17.7-.7 1.6L4.4 27l.8-1.5 4.5-9V29h17V15.6l5.5 7.7 1.5 2.1zm2.5-2.9l-2.3 1.9-.6-.7 2.3-1.9.6.7zM22.8 3.6l-2.6 1.9-.8-.6 2.8-2.7.6 1.4zm-1.1-2l-1.4 1.3h-3.4l-1.4-1.3h6.2zm-6.6.5l2.8 2.7-.8.6-2.7-1.9.7-1.4zm-10.9 24l-2.5-1.8.4-1 2.6 1.9-.5.9zM9.7 15l-4.8 9.6-2.6-1.9 7.8-16.5v.4c.1 1.8.1 5.3-.4 8.4zm8.6 13.3h-7.9v-1.1h7.9v1.1zm0-1.9h-7.9V15.2c.6-3.9.5-8.4.4-9.7v-.1l3.5-1.2 2.9 2.1 1.1-.9v21zm-.7-22.8h2l-1 1-1-1zm8.5 24.7H19v-1.1h7.1v1.1zm0-1.9H19v-21l1.2.9 2.9-2.1 2.6.9v.1c0 .9-.2 5.8.4 10v11.2zm.6-12c-.4-3.5-.4-7.3-.3-8.8v-.4l.2.3 8.7 15.6-2.4 1.9-6.2-8.6z"/><path d="M20.7 13.6h3.2V9.4h-3.2v4.2zm.7-3.5h1.8v2.8h-1.8v-2.8zm-9.6 12.6l.9 1 3.7-3.1-.9-1-3.7 3.1zm.9.5l-.4-.4 3.1-2.6.4.4-3.1 2.6zm7.7-3l3.1 3.7 1-.9-3.1-3.7-1 .9zm3.1 3.2l-2.6-3.1.4-.4 2.6 3.1-.4.4z"/>
                  </svg>
                </span>
                <span class="text">Match Jacket</span>
              </a>
            </div>
            <div class="product-data__sizing my-2">
              <ul class="flex flex-wrap gap-2 OLD: sizing product-outfit" data-id=""></ul>
            </div>`,
      )
      .addClass('hidden'),
    $(
      'div#review div.outfit-cart div.outfit-cart__items div.cart-row.clothing div.cart-item.item-4',
    )
      .empty()
      .append(
        //'<div class="cart-item__image"><img class="preview" src="#"></div><div class="cart-item__info"><div class="info-top"><p class="title"></p><p class="size"></p><div class="price"></div></div><div class="info-bottom"><div class="quantity-btns"><button type="button" class="minus outfit-quantity"><span class="text">-</span></button><div class="quantity"><span class="quantity__input">1</span></div><button type="button" class="plus outfit-quantity"><span class="text">+</span></button></div></div></div><input type="hidden" id="cart-item-clothing-4" value="" data-notice="" data-quantity="1" data-cost="0">',
        `
                    <div class="cart-item__image">
                      <img class="preview" src="#">
                    </div>
                    <div class="p-2 text-md OLD: cart-item__info">
                      <p class="text-scheme-links OLD: title"></p>
                      <p class="size"></p>
                      <div class="text-scheme-links OLD: price"></div>
                    </div>
                    <input
                      type="hidden"
                      id="cart-item-clothing-4"
                      value=""
                      data-notice=""
                      data-quantity="1"
                      data-cost="0"
                    >`,
      )
      .addClass('hidden'),
    $('div.outfits__slider div.outfit').each(function (t, i) {
      $(this).removeClass('outline');
    }),
    t.toggleClass('outline'));
  var i = t.attr('data-products').split(',');
  i.length > 0 &&
    $(
      'div.outfit-filter div.column.product-filters div.product-filters__products div.products div.product',
    ).each(function (t) {
      var e = $(this).attr('data-id');
      $.inArray(e, i) > -1 && $(this).trigger('click');
    });
}
function reset_product_filters(t, i) {
  ($(
    'div.outfit-filter[data-item="' +
      t +
      '"] div.column.product-filters ul.colours li[data-colour="all-colours"]',
  ).click(),
    $(
      'div.outfit-filter[data-item="' +
        t +
        '"] div.column.product-filters ul.tags li[data-tag="all-tags"]',
    ).click(),
    $(document).ajaxStop(function () {
      $('div.outfit-filter[data-item="' + t + '"]')
        .find(
          'div.column.product-filters div.product-filters__products div.products div.product[data-id="' +
            i +
            '"]',
        )
        .trigger('click');
    }));
}
(!(function (t) {
  ((t.isScrollToFixed = function (i) {
    return !!t(i).data('ScrollToFixed');
  }),
    (t.ScrollToFixed = function (i, e) {
      var a = this;
      ((a.$el = t(i)), (a.el = i), a.$el.data('ScrollToFixed', a));
      var s,
        o,
        r,
        d,
        n = !1,
        c = a.$el,
        l = 0,
        p = 0,
        u = -1,
        v = -1,
        f = null;
      function m() {
        var t = a.options.limit;
        return t ? ('function' == typeof t ? t.apply(c) : t) : 0;
      }
      function h() {
        return 'fixed' === s;
      }
      function g() {
        return 'absolute' === s;
      }
      function _() {
        return !(h() || g());
      }
      function x() {
        if (!h()) {
          var t = c[0].getBoundingClientRect();
          (f.css({
            display: c.css('display'),
            width: t.width,
            height: t.height,
            float: c.css('float'),
          }),
            (cssOptions = {
              'z-index': a.options.zIndex,
              position: 'fixed',
              top: -1 == a.options.bottom ? y() : '',
              bottom: -1 == a.options.bottom ? '' : a.options.bottom,
              'margin-left': '0px',
            }),
            a.options.dontSetWidth || (cssOptions.width = c.css('width')),
            c.css(cssOptions),
            c.addClass(a.options.baseClassName),
            a.options.className && c.addClass(a.options.className),
            (s = 'fixed'));
        }
      }
      function $() {
        var t = m(),
          i = p;
        (a.options.removeOffsets && ((i = ''), (t -= l)),
          (cssOptions = {
            position: 'absolute',
            top: t,
            left: i,
            'margin-left': '0px',
            bottom: '',
          }),
          a.options.dontSetWidth || (cssOptions.width = c.css('width')),
          c.css(cssOptions),
          (s = 'absolute'));
      }
      function w() {
        _() ||
          ((v = -1),
          f.css('display', 'none'),
          c.css({ 'z-index': d, width: '', position: o, left: '', top: r, 'margin-left': '' }),
          c.removeClass('scroll-to-fixed-fixed'),
          a.options.className && c.removeClass(a.options.className),
          (s = null));
      }
      function b(t) {
        t != v && (c.css('left', p - t), (v = t));
      }
      function y() {
        var t = a.options.marginTop;
        return t ? ('function' == typeof t ? t.apply(c) : t) : 0;
      }
      function F() {
        if (t.isScrollToFixed(c) && !c.is(':hidden')) {
          var i = n,
            e = _();
          n
            ? _() && ((l = c.offset().top), (p = c.offset().left))
            : (c.trigger('preUnfixed.ScrollToFixed'),
              w(),
              c.trigger('unfixed.ScrollToFixed'),
              (v = -1),
              (l = c.offset().top),
              (p = c.offset().left),
              a.options.offsets && (p += c.offset().left - c.position().left),
              -1 == u && (u = p),
              (s = c.css('position')),
              (n = !0),
              -1 != a.options.bottom &&
                (c.trigger('preFixed.ScrollToFixed'), x(), c.trigger('fixed.ScrollToFixed')));
          var r = t(window).scrollLeft(),
            d = t(window).scrollTop(),
            f = m();
          (a.options.minWidth && t(window).width() < a.options.minWidth) ||
          (a.options.maxWidth && t(window).width() > a.options.maxWidth)
            ? (_() && i) ||
              (z(), c.trigger('preUnfixed.ScrollToFixed'), w(), c.trigger('unfixed.ScrollToFixed'))
            : -1 == a.options.bottom
              ? f > 0 && d >= f - y()
                ? e ||
                  (g() && i) ||
                  (z(),
                  c.trigger('preAbsolute.ScrollToFixed'),
                  $(),
                  c.trigger('unfixed.ScrollToFixed'))
                : d >= l - y()
                  ? ((h() && i) ||
                      (z(),
                      c.trigger('preFixed.ScrollToFixed'),
                      x(),
                      (v = -1),
                      c.trigger('fixed.ScrollToFixed')),
                    b(r))
                  : (_() && i) ||
                    (z(),
                    c.trigger('preUnfixed.ScrollToFixed'),
                    w(),
                    c.trigger('unfixed.ScrollToFixed'))
              : f > 0
                ? d + t(window).height() - c.outerHeight(!0) >=
                  f -
                    (y() ||
                      -(function () {
                        if (!a.options.bottom) return 0;
                        return a.options.bottom;
                      })())
                  ? h() &&
                    (z(),
                    c.trigger('preUnfixed.ScrollToFixed'),
                    'absolute' === o ? $() : w(),
                    c.trigger('unfixed.ScrollToFixed'))
                  : (h() || (z(), c.trigger('preFixed.ScrollToFixed'), x()),
                    b(r),
                    c.trigger('fixed.ScrollToFixed'))
                : b(r);
        }
      }
      function z() {
        var t = c.css('position');
        'absolute' == t
          ? c.trigger('postAbsolute.ScrollToFixed')
          : 'fixed' == t
            ? c.trigger('postFixed.ScrollToFixed')
            : c.trigger('postUnfixed.ScrollToFixed');
      }
      var S = function (t) {
          c.is(':visible') ? ((n = !1), F()) : w();
        },
        T = function (t) {
          window.requestAnimationFrame ? requestAnimationFrame(F) : F();
        };
      ((a.init = function () {
        ((a.options = t.extend({}, t.ScrollToFixed.defaultOptions, e)),
          (d = c.css('z-index')),
          a.$el.css('z-index', a.options.zIndex),
          (f = t('<div />')),
          (s = c.css('position')),
          (o = c.css('position')),
          c.css('float'),
          (r = c.css('top')),
          _() && a.$el.after(f),
          t(window).bind('resize.ScrollToFixed', S),
          t(window).bind('scroll.ScrollToFixed', T),
          'ontouchmove' in window && t(window).bind('touchmove.ScrollToFixed', F),
          a.options.preFixed && c.bind('preFixed.ScrollToFixed', a.options.preFixed),
          a.options.postFixed && c.bind('postFixed.ScrollToFixed', a.options.postFixed),
          a.options.preUnfixed && c.bind('preUnfixed.ScrollToFixed', a.options.preUnfixed),
          a.options.postUnfixed && c.bind('postUnfixed.ScrollToFixed', a.options.postUnfixed),
          a.options.preAbsolute && c.bind('preAbsolute.ScrollToFixed', a.options.preAbsolute),
          a.options.postAbsolute && c.bind('postAbsolute.ScrollToFixed', a.options.postAbsolute),
          a.options.fixed && c.bind('fixed.ScrollToFixed', a.options.fixed),
          a.options.unfixed && c.bind('unfixed.ScrollToFixed', a.options.unfixed),
          a.options.spacerClass && f.addClass(a.options.spacerClass),
          c.bind('resize.ScrollToFixed', function () {
            f.height(c.height());
          }),
          c.bind('scroll.ScrollToFixed', function () {
            (c.trigger('preUnfixed.ScrollToFixed'), w(), c.trigger('unfixed.ScrollToFixed'), F());
          }),
          c.bind('detach.ScrollToFixed', function (i) {
            (!(function (t) {
              ((t = t || window.event).preventDefault && t.preventDefault(), (t.returnValue = !1));
            })(i),
              c.trigger('preUnfixed.ScrollToFixed'),
              w(),
              c.trigger('unfixed.ScrollToFixed'),
              t(window).unbind('resize.ScrollToFixed', S),
              t(window).unbind('scroll.ScrollToFixed', T),
              c.unbind('.ScrollToFixed'),
              f.remove(),
              a.$el.removeData('ScrollToFixed'));
          }),
          S());
      }),
        a.init());
    }),
    (t.ScrollToFixed.defaultOptions = {
      marginTop: 0,
      limit: 0,
      bottom: -1,
      zIndex: 1e3,
      baseClassName: 'scroll-to-fixed-fixed',
    }),
    (t.fn.scrollToFixed = function (i) {
      return this.each(function () {
        new t.ScrollToFixed(this, i);
      });
    }));
})(jQuery),
  $(window).on('scroll', function () {
    var t = window.pageYOffset;
    $('div.accordion').each(function () {
      var i = $(this).offset().top - 146,
        e = $(this).attr('id'),
        a = $('div.outfit-builder__breadcrumbs a');
      t >= i &&
        (a.removeClass('text-scheme-links'),
        $('div.outfit-builder__breadcrumbs a[href="#' + e + '"]').addClass('text-scheme-links'));
    });
  }),
  $('div.outfit-builder__breadcrumbs').scrollToFixed({ marginTop: 90 }),
  $(document).on('click', 'a.notice-link', function (t) {
    var i = $(this.hash);
    (i = i.length ? i : $('[name=' + this.hash.slice(1) + ']')).length &&
      $('html, body').animate({ scrollTop: i.offset().top - 145 }, 1e3);
  }),
  $(document).on('click', 'div.product-filters__colours ul.colours li', function () {
    ((product_filter = $(this).parents('div.product-filters')),
      'all-colours' == $(this).data('colour')
        ? product_filter.find('ul.colours li').each(function (t, i) {
            $(this).removeClass('outline');
          })
        : product_filter.find('ul.colours li[data-colour="all-colours"]').hasClass('outline') &&
          product_filter.find('ul.colours li[data-colour="all-colours"]').removeClass('outline'),
      $(this).toggleClass('outline'),
      get_selected_filters(product_filter),
      filter_outfits(product_filter));
  }),
  $(document).on('click', 'div.product-filters__tags ul.tags li', function () {
    var t = $(this).parents('div.product-filters');
    ('all-tags' == $(this).data('tag')
      ? t.find('ul.tags li').each(function (t, i) {
          $(this).removeClass('outline');
        })
      : t.find('ul.tags li[data-tag="all-tags"]').hasClass('outline') &&
        t.find('ul.tags li[data-tag="all-tags"]').removeClass('outline'),
      $(this).toggleClass('outline'),
      get_selected_filters(t),
      filter_outfits(t));
  }),
  $(document).on('click', 'div.product-filters__products div.products div.product', function () {
    var t = $(this).parents('div.accordion').attr('id'),
      i = $(this).parents('div.outfit-filter').data('item'),
      e = $(this).parents('div.outfit-filter').data('type');
    ($(this)
      .parent('div.products')
      .find('div.product')
      .each(function (t, i) {
        $(this).removeClass('outline');
      }),
      $(this).addClass('outline'));
    var a = $(this).find('.image-wrapper').attr('data-src'),
      s = $(this).find('.image-wrapper').attr('data-rollover');
    ($(this)
      .parents('div.outfit-filter')
      .find('div.product-preview')
      .find('img.preview')
      .attr('src', a),
      $(this)
        .parents('div.outfit-filter')
        .find('div.product-preview')
        .find('img.rollover')
        .attr('src', s),
      $(this)
        .parents('div.outfit-filter')
        .find('div.product-preview')
        .find('div.image-wrapper')
        .removeClass('hidden'));
    var o = JSON.parse($(this).children('#product-json').html());
    if (o) {
      var r = o.title.split('|'),
        d = r.length,
        n = '';
      ($.each(r, function (t, i) {
        n += t == d - 1 ? i : i + '<br>';
      }),
        $(this).parents('div.outfit-filter').find('p.title').html(n));
      var c = '';
      if (
        (null !== o.compare_at_price && parseInt(o.compare_at_price) > parseInt(o.price)
          ? (c +=
              '<span class="price now sale"><span class="money" data-currency-gbp="£' +
              (o.price / 100).toFixed(2) +
              '">' +
              currency_symbol +
              (o.price / 100).toFixed(2) +
              '</span></span><span class="price was"><span class="money" data-currency-gbp="£' +
              (o.compare_at_price / 100).toFixed(2) +
              '">' +
              currency_symbol +
              (o.compare_at_price / 100).toFixed(2) +
              '</span></span>')
          : (c +=
              '<span class="price"><span class="money" data-currency-gbp="£' +
              (o.price / 100).toFixed(2) +
              '">' +
              currency_symbol +
              (o.price / 100).toFixed(2) +
              '</span></span>'),
        $(this).parents('div.outfit-filter').find('div.price').html(c),
        o.variants.length > 0)
      ) {
        var l = $(this).parents('div.outfit-filter').find('ul.sizing');
        (l.attr('data-id', o.id),
          l.empty(),
          $.each(o.variants, function (t, i) {
            var e = '';
            (i.title.length > 3 && (e += ' wide'),
              i.inventory_quantity > 0
                ? l.append(
                    '<li class="min-w-8 h-8 outline-1 outline-offset-2 outline-scheme-links border border-scheme-border rounded-full px-2 whitespace-nowrap text-xs flex items-center justify-center cursor-pointer text-scheme-links OLD: in-stock' +
                      e +
                      '" data-id="' +
                      i.id +
                      '" data-title="' +
                      i.title +
                      '" data-quantity="' +
                      i.inventory_quantity +
                      '"><span class="sizing__text">' +
                      i.title +
                      '</span></li>',
                  )
                : l.append(
                    '<li class="min-w-8 h-8 outline-1 outline-offset-2 outline-scheme-links border border-scheme-border rounded-full px-2 whitespace-nowrap text-xs flex items-center justify-center cursor-not-allowed OLD: not-available' +
                      e +
                      '" data-id="' +
                      i.id +
                      '" data-title="' +
                      i.title +
                      '" data-quantity="' +
                      i.inventory_quantity +
                      '"><span class="sizing__text">' +
                      i.title +
                      '</span>' +
                      //'<span class="sizing__icon"><svg version="1.1" id="envelope" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 9"><path d="M12.5,3.25V7.45c0,.28-.11,.55-.32,.74s-.48,.31-.77,.31H1.59c-.29,0-.57-.11-.77-.31s-.32-.46-.32-.74V3.25" style="fill:none;"/><path d="M11.41,9H1.59c-.42,0-.82-.16-1.12-.45-.31-.29-.47-.69-.47-1.1V2.75H1V7.45c0,.14,.06,.28,.17,.38,.11,.11,.27,.17,.42,.17H11.41c.16,0,.31-.06,.43-.17,.11-.1,.17-.24,.17-.38V2.75h1V7.45c0,.41-.17,.81-.47,1.1-.3,.29-.7,.45-1.12,.45Z"/><g><path d="M12.5,2.6V1.55c0-.28-.11-.55-.32-.74-.2-.2-.48-.31-.77-.31H1.59c-.29,0-.57,.11-.77,.31-.2,.2-.32,.46-.32,.74v1.05l6,3.15,6-3.15Z" style="fill:none;"/><path d="M6.5,6.31L0,2.9V1.55C0,1.14,.17,.74,.47,.45c.3-.29,.7-.45,1.12-.45H11.41c.42,0,.82,.16,1.12,.45,.3,.29,.47,.69,.47,1.1v1.35l-6.5,3.41ZM1,2.3l5.5,2.88,5.5-2.88v-.75c0-.14-.06-.28-.17-.38-.11-.11-.27-.17-.42-.17H1.59c-.16,0-.31,.06-.42,.17-.11,.1-.17,.24-.17,.38v.75Zm11.5,.3h0Z"/></g></svg></span><span class="sizing__tooltip">Notify me when back in stock</span>' +
                      '</li>',
                  ));
          }));
      }
      if (
        ($(this)
          .parents('div.outfit-filter')
          .find('a.quickview')
          .attr('data-src', o.url + '?view=quick'),
        null !== o.jacket_match &&
          $(this)
            .parents('div.outfit-filter')
            .find('a.jacket-match')
            .attr('data-products', o.jacket_match)
            .removeClass('hidden'),
        null !== o.trouser_match &&
          $(this)
            .parents('div.outfit-filter')
            .find('a.trouser-match')
            .attr('data-products', o.trouser_match)
            .removeClass('hidden'),
        $(this).parents('div.outfit-filter').find('div.product-data').removeClass('hidden'),
        'clothing' == e)
      )
        ($(
          'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
            e +
            ' div.cart-item.item-' +
            i,
        )
          .find('img.preview')
          .attr('src', a),
          $(
            'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
              e +
              ' div.cart-item.item-' +
              i,
          )
            .find('p.title')
            .html(n),
          $(
            'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
              e +
              ' div.cart-item.item-' +
              i,
          )
            .find('p.size')
            .html(
              '<a class="notice-link" href="#' +
                t +
                '">Size: <span class="selected-size">Please Select</span></a>',
            )
            .addClass('empty'),
          $(
            'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
              e +
              ' div.cart-item.item-' +
              i,
          )
            .find('div.price')
            .html(c),
          $(
            'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
              e +
              ' div.cart-item.item-' +
              i,
          )
            .find('input#cart-item-' + e + '-' + i)
            .attr('data-cost', o.price)
            .attr('data-notice', $.trim(r[0])),
          $('div#review div.outfit-cart div.outfit-cart__items div.cart-row.' + e).removeClass(
            'hidden',
          ),
          $(
            'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
              e +
              ' div.cart-item.item-' +
              i,
          ).removeClass('hidden'));
      else {
        var p = 1;
        $(
          'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' + e + ' div.cart-item',
        ).each(function (t, i) {
          p++;
        });
        var u =
          '<div class="cart-item item-' +
          p +
          '" data-item="' +
          p +
          '" data-id="' +
          o.id +
          '"><div class="cart-item__image"><img class="preview" src="' +
          a +
          '"></div><div class="cart-item__info"><div class="info-top"><p class="title">' +
          n +
          '</p><p class="size empty"><a class="notice-link" href="#' +
          t +
          '">Size: <span class="selected-size">Please Select</span></a></p><div class="price">' +
          c +
          '</div></div><div class="info-bottom"><div class="quantity-btns"><button type="button" class="minus outfit-quantity"><span class="text">-</span></button><div class="quantity"><span class="quantity__input">1</span></div><button type="button" class="plus outfit-quantity"><span class="text">+</span></button></div></div></div><input type="hidden" id="cart-item-accessories-' +
          o.id +
          '" value="" data-notice="' +
          $.trim(r[0]) +
          '" data-quantity="1" data-cost="' +
          o.price +
          '">';
        ($('div#review div.outfit-cart div.outfit-cart__items div.cart-row.' + e).append(u),
          $('div#review div.outfit-cart div.outfit-cart__items div.cart-row.' + e).removeClass(
            'hidden',
          ));
      }
      update_outfit_cart();
    }
  }),
  $(document).on('click', 'div.product-preview div.image-wrapper span.preview-btn', function () {
    ($(this).toggleClass('active'), $(this).parent('div.image-wrapper').toggleClass('active'));
  }),
  $(document).on('click', 'div.outfits__slider div.outfit', function () {
    ((tags_array = []),
      $('div.outfit-filter').each(function (t, i) {
        var e = $(this).find('input#outfit-filter-tags').val().split(', ');
        $.merge(tags_array, e);
      }),
      $.unique(tags_array.sort()));
    var t = $(this);
    tags_array.length > 2 ? reset_preselected_outfits(t) : filter_preselected_outfits(t);
  }),
  $('div.outfit-builder__inspiration div.outfits div.outfits__slider div.outfit.outfit-1').length >
    0 &&
    $(
      'div.outfit-builder__inspiration div.outfits div.outfits__slider div.outfit.outfit-1',
    )[0].click(),
  $(document).on(
    'click',
    'div.outfit-filter div.column.product-data div.product-data__match a.product-match',
    function (t) {
      if ((t.preventDefault(), $(this).toggleClass('outline'), $(this).hasClass('trouser-match')))
        var i = 2;
      else i = 1;
      $('input#cart-item-clothing-' + i).val('');
      var e = $(this).attr('data-products');
      if (e.length > 0) {
        var a = $('div.outfit-filter[data-item="' + i + '"]')
          .find('input#outfit-filter-tags')
          .val()
          .split(', ');
        -1 == $.inArray('all-colours', a) || -1 == $.inArray('all-tags', a)
          ? reset_product_filters(i, e)
          : $('div.outfit-filter[data-item="' + i + '"]')
              .find(
                'div.column.product-filters div.product-filters__products div.products div.product[data-id="' +
                  e +
                  '"]',
              )
              .trigger('click');
      }
    },
  ),
  $(document).on('click', 'div.product-data__sizing ul.sizing.product-outfit li', function () {
    if (!$(this).hasClass('not-available')) {
      var t = $(this).parents('div.outfit-filter').attr('data-type'),
        i = $(this).parents('div.accordion').attr('id'),
        e = $(this).attr('data-id'),
        a = $(this).attr('data-title');
      if ('accessories' == t) {
        var s = $(this).parent('ul.sizing').attr('data-id');
        $(this).hasClass('outline')
          ? ($(
              'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
                t +
                ' div.cart-item[data-id="' +
                s +
                '"]',
            )
              .find('input#cart-item-' + t + '-' + s)
              .val(''),
            $(
              'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
                t +
                ' div.cart-item[data-id="' +
                s +
                '"]',
            )
              .find('p.size')
              .html(
                '<a class="notice-link" href="#' +
                  i +
                  '">Size: <span class="selected-size">Please Select</span></a>',
              )
              .addClass('empty'))
          : ($(
              'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
                t +
                ' div.cart-item[data-id="' +
                s +
                '"]',
            )
              .find('input#cart-item-' + t + '-' + s)
              .val(e),
            $(
              'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
                t +
                ' div.cart-item[data-id="' +
                s +
                '"]',
            )
              .find('p.size')
              .html('Size: <span class="selected-size">' + a + '</span>')
              .removeClass('empty'));
      } else {
        s = $(this).parents('div.outfit-filter').attr('data-item');
        $(this).hasClass('outline')
          ? ($(
              'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
                t +
                ' div.cart-item.item-' +
                s,
            )
              .find('input#cart-item-' + t + '-' + s)
              .val(''),
            $(
              'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
                t +
                ' div.cart-item.item-' +
                s,
            )
              .find('p.size')
              .html(
                '<a class="notice-link" href="#' +
                  i +
                  '">Size: <span class="selected-size">Please Select</span></a>',
              )
              .addClass('empty'))
          : ($(
              'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
                t +
                ' div.cart-item.item-' +
                s,
            )
              .find('input#cart-item-' + t + '-' + s)
              .val(e),
            $(
              'div#review div.outfit-cart div.outfit-cart__items div.cart-row.' +
                t +
                ' div.cart-item.item-' +
                s,
            )
              .find('p.size')
              .html('Size: <span class="selected-size">' + a + '</span>')
              .removeClass('empty'));
      }
      ($(this).siblings().removeClass('outline'),
        $(this).toggleClass('outline'),
        update_outfit_cart());
    }
  }),
  $(document).on('click', '.outfit-add-to-bag', function (t) {
    if ((t.preventDefault(), !$(this).prop('disabled'))) {
      var i = [];
      (i.push({ quantity: 1, id: parseInt($('input#cart-item-clothing-1').val()) }),
        i.push({ quantity: 1, id: parseInt($('input#cart-item-clothing-2').val()) }),
        i.push({ quantity: 1, id: parseInt($('input#cart-item-clothing-3').val()) }),
        '' !== $('input#cart-item-clothing-4').val() &&
          i.push({ quantity: 1, id: parseInt($('input#cart-item-clothing-4').val()) }),
        i.length > 0 &&
          $.ajax({
            url: '/cart/add',
            dataType: 'json',
            method: 'POST',
            data: { items: i },
            error: function (t, i, e) {
              422 == t.status &&
                $.fancybox.open({
                  src: '#sizing-error',
                  clickOutside: !1,
                  clickSlide: !1,
                  autoFocus: !1,
                  arrows: !1,
                  touch: !1,
                  btnTpl: {
                    close: !1,
                    smallBtn:
                      '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg><span class="text">Close</span></button>',
                    arrowLeft: '',
                    arrowRight: '',
                  },
                });
            },
          }).done(function (t) {
            $.fancybox.close();
            var i = $('input#cart-calculations').val();
            '' !== i && (window.location.href = '/checkout?discount=' + encodeURI(i));
          }));
    }
  }));
